import { Component, inject } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { NavbarComponent } from './navbar/navbar.component';
import { NavigationDrawerComponent } from './navigation-drawer/navigation-drawer.component';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { NavBarService } from './nav-bar.service';
import { CampaignBannerComponent } from '../campaign-banner/campaign-banner.component';
import { CustomToastComponent } from 'src/app/shared/components/custom-toast/custom-toast.component';
import { TourService } from '../../core/services/tour.service';
import { filter } from 'rxjs';
import { TourPopoverComponent } from 'src/app/shared/components/tour-popover/tour-popover.component';
import { ProfileService } from 'src/app/features/profile/services/profile.service';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    NavbarComponent,
    NavigationDrawerComponent,
    CommonModule,
    ButtonModule,
    CampaignBannerComponent,
    CustomToastComponent,
    TourPopoverComponent,
  ],
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent {
  private readonly navBarService = inject(NavBarService);
  private readonly router = inject(Router);
  private readonly tourService = inject(TourService);
  private readonly profileService = inject(ProfileService);

  readonly isNavDrawerOpen = this.navBarService.isNavDrawerOpen;

  private tourStarted = false;

  constructor() {
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
      )
      .subscribe(() => this.tryStartTour());
  }

  get isHomePage(): boolean {
    return this.router.url === '/';
  }

  private tryStartTour(): void {
    if (
      this.tourStarted ||
      !this.tourService.shouldShowTour() ||
      this.profileService.isProfileIncomplete !== false
    ) {
      return;
    }

    this.tourStarted = true;

    // Ensure the desktop drawer is open and mobile drawer is closed before
    // the tour initialises, so step elements in the sidebar are in the DOM.
    this.navBarService.isNavDrawerOpen.set(true);
    this.navBarService.isNavDrawerOpenMobile.set(false);

    setTimeout(() => this.tourService.startTour(), 1000);
  }
}
